export default __webpack_public_path__ + "static/media/modus_operandi_img.2c0c3f4e.png";